export default __webpack_public_path__ + "static/media/ToDoListPRO.806707e3.jpg";